import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface ErrorBoxProps {
  errorMessage: string;
  marginBottom?: number;
  marginTop?: number;
  justify?: string;
}

function ErrorBox({
  errorMessage,
  marginBottom = 1,
  marginTop = 0,
  justify = 'flex-start',
}: ErrorBoxProps) {
  return (
    <>
      {!!errorMessage && (
        <Box display="flex" justifyContent={justify}>
          <Typography color="red" sx={{ fontSize: 12, marginBottom, marginTop }}>
            {errorMessage}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default ErrorBox;
